import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Reports",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.7 2.01H5.3C3.48 2.01 2 3.48 2 5.31v21.38c0 1.82 1.47 3.3 3.3 3.3h21.39c1.82 0 3.3-1.47 3.3-3.3V5.3c0-1.82-1.47-3.3-3.3-3.3Zm-.76 22.2c0 .51-.41.92-.92.92H6.99c-.51 0-.92-.41-.92-.92v-7.84c0-.51.41-.92.92-.92H8.6c.51 0 .92.41.92.92v6.92h2.01V12.45c0-.51.41-.92.92-.92h1.61c.51 0 .92.41.92.92v10.8h2.08V6.97c0-.51.41-.92.92-.92h1.61c.49.01.89.42.89.92V23.3h2.04V10.89c0-.51.41-.92.92-.92h1.61c.5 0 .9.39.92.89v13.35l-.02.02Z"
    })
  }));
};